import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CountriesModule } from '@nibtravel/shared/data-access/countries';
import { QuoteStateModule } from '@nibtravel/shared/data-access/quote';
import { AutocompleteModule } from '@nibtravel/shared/ui/forms/autocomplete';
import { DropdownModule } from '@nibtravel/shared/ui/forms/dropdown';
import { ListModule } from '@nibtravel/shared/ui/pipes/list';
import { i18nModule } from '@nibtravel/shared/util/i18n';

import { DestinationPipe } from './destination.pipe';
import { QqcDestinationComponent } from './qqc-destination.component';
import { AlertModule } from '@nibtravel/shared/ui/components/alert';
import { PopularCountrySuggestionsComponent } from './popularCountrySuggestions/popularCountrySuggestions.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutocompleteModule,
    CountriesModule,
    QuoteStateModule,
    DropdownModule,
    ListModule,
    AlertModule,
    i18nModule.forChild({
      scope: 'qqc/destination',
      alias: 'destination',
    }),
  ],
  declarations: [
    QqcDestinationComponent,
    DestinationPipe,
    PopularCountrySuggestionsComponent,
  ],
  exports: [QqcDestinationComponent, DestinationPipe],
  providers: [DestinationPipe],
})
export class QqcDestinationModule {}
